import Programs from 'components/global/Programs/Programs';

const VCPrograms = () => <Programs />;

export default VCPrograms;
